/* eslint-disable no-nested-ternary */
import { FC, useCallback, useState } from 'react'
import { Table, Toolbar, Button, Modal } from 'shared'
import { SortType } from 'rsuite-table'
import { IFilter, Operator } from 'api/types'
import { useTableHandlers } from 'hooks/useTableHandlers'
import '../../../scss/common/list/List.scss'
import { notifyError, notifySuccess, notifyWarning } from 'utils'
import { DateTimeCell } from 'shared/molecules/table/cells'
import DescriptionCell from 'shared/molecules/table/cells/DescriptionCell'
import useAuth from '../../../hooks/Auth'

import CreateEditCampaign from '../createEditCampaign/createEditCampaign'
import {
  useGetAllCampaignsQuery,
  useDeleteCampaignMutation,
  useGetAppCampaignsQuery
} from '../campaignApiSlice'
import {
  AppCampaignListRequest,
  Campaign,
  CampaignListRequest,
  CHANNEL
} from '../types'

const { Column, HeaderCell, Cell, ActionCell, CampaignStatusCell } = Table
const Campaigncolumns = [
  { key: 'name', label: 'Name', width: 270 },
  { key: 'scheduleDateTime', label: 'Shedule Date Time', width: 150 },
  { key: 'channel', label: 'Channel Type', width: 150 },
  { key: 'description', label: 'Description', width: 170 },
  { key: 'status', label: 'Status', width: 150 }
]

const AppCampaignColumns = [
  { key: 'name', label: 'Name', width: 270 },
  { key: 'scheduleDateTime', label: 'Start Date', width: 150 },
  { key: 'scheduleEndDate', label: 'End Date', width: 150 },
  { key: 'channel', label: 'Channel Type', width: 150 },
  { key: 'description', label: 'Description', width: 170 },
  { key: 'status', label: 'Status', width: 150 }
]

const CampaignList: FC = () => {
  const [openCampaignmodal, setopenCampaignmodal] = useState<boolean>(false)
  const { setopenEditProfile, isSubsId, isCompanyVerified } = useAuth()
  const [activeTab, setActiveTab] = useState<CHANNEL>(CHANNEL.WHATSAPP)
  const [deleteCampaign] = useDeleteCampaignMutation()
  const [selectedCampaign, setSelectedCampaign] = useState<Campaign | null>(
    null
  )
  const [isEditMode, setIsEditMode] = useState<boolean>(false)
  const [isCopyMode, setIsCopyMode] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [showCopyModal, setCopyModal] = useState<boolean>(false)

  const {
    requestBody,
    onPageChange,
    onSortColumn,
    onSearchChange,
    onFilterChange
  } = useTableHandlers<Campaign, CampaignListRequest>(
    {
      filters: [
        {
          fieldName: 'channel',
          operator: Operator.EQ,
          fieldValue: activeTab
        }
      ],
      page: { size: 10, number: 1 }
    },
    'name'
  )

  const { data, isLoading } = useGetAllCampaignsQuery(
    activeTab !== 'INAPP'
      ? (requestBody as CampaignListRequest)
      : ({} as CampaignListRequest),
    { skip: activeTab === 'INAPP' }
  )

  const { data: appCampaignData, isLoading: isAppCampaignLoading } =
    useGetAppCampaignsQuery(
      activeTab === 'INAPP'
        ? (requestBody as AppCampaignListRequest)
        : ({} as AppCampaignListRequest),
      { skip: activeTab !== 'INAPP' }
    )
  const campaignData = activeTab === 'INAPP' ? appCampaignData : data
  const total =
    campaignData?.totalElements ?? campaignData?.content?.length ?? 0
  const columns = activeTab === 'INAPP' ? AppCampaignColumns : Campaigncolumns
  const handleSortColumn = useCallback(
    (column: string, type?: SortType) => {
      onSortColumn(column, type)
    },
    [onSortColumn]
  )
  const handleTabChange = (tab: CHANNEL) => {
    setActiveTab(tab)
    const newFilter: IFilter<Campaign> = {
      fieldName: 'channel',
      operator: Operator.EQ,
      fieldValue: tab
    }
    onFilterChange([newFilter])
  }
  const dropdownOptions = [
    { label: 'Schedule', value: 'Schedule' },
    { label: 'Draft', value: 'Draft' },
    { label: 'Process', value: 'Process' }
  ]
  const options = [
    {
      label: 'Whatsapp',
      value: CHANNEL.WHATSAPP,
      onClick: () => handleTabChange(CHANNEL.WHATSAPP)
    },
    {
      label: 'SMS',
      value: CHANNEL.SMS,
      onClick: () => handleTabChange(CHANNEL.SMS)
    },
    {
      label: 'APP',
      value: CHANNEL.INAPP,
      onClick: () => handleTabChange(CHANNEL.INAPP)
    }
  ]
  const handleDropdown = (value: string) => {
    const compaignFilter: IFilter<Campaign> = {
      fieldName: 'status',
      operator: Operator.EQ,
      fieldValue: value ?? ''
    }

    const updatedFilters = [
      compaignFilter,
      ...(requestBody.filters ?? []).filter((f) => f.fieldName !== 'status')
    ]
    onFilterChange(updatedFilters)
  }

  const handleCompaignAction = () => {
    if (!isSubsId) {
      setopenEditProfile(true)
    } else if (!isCompanyVerified) {
      notifyWarning(
        'Sorry, your company documents are not verified yet. Once they verified, our team will contact you soon.'
      )
    } else {
      setSelectedCampaign(null)
      setIsEditMode(false)
      setopenCampaignmodal(true)
    }
  }
  const renderCellComponent = (key: string) => {
    if (key === 'scheduleDateTime' || key === 'scheduleEndDate') {
      return <DateTimeCell dataKey={key} format="yyyy/MM/dd" />
    }

    if (key === 'status') {
      return <CampaignStatusCell dataKey={key} />
    }
    if (key === 'description') {
      return <DescriptionCell dataKey={key} />
    }

    return <Cell dataKey={key} />
  }
  const onclose = () => {
    setSelectedCampaign(null)
    setopenCampaignmodal(false)
    setopenEditProfile(false)
    setIsEditMode(false)
    setIsCopyMode(false)
  }
  const handleConfirmDelete = async () => {
    if (!selectedCampaign?.id) {
      notifyError('Campaign ID is missing.')
      return
    }
    try {
      await deleteCampaign({ id: selectedCampaign.id }).unwrap()
      notifySuccess('Campaign deleted successfully.')
      setShowDeleteModal(false)
    } catch (error) {
      notifyError('Failed to Delete Compaign', { containerId: 'modalToast' })
    }
  }
  const handleConfirmCopy = async (rowData: Campaign) => {
    setIsCopyMode(true)
    setopenCampaignmodal(true)
    setSelectedCampaign(rowData)
    setCopyModal(false)
  }
  const handleAction = async (
    action: string | undefined,
    rowData: Campaign
  ) => {
    switch (action) {
      case '2':
        setSelectedCampaign(rowData)
        setIsEditMode(true)
        setopenCampaignmodal(true)
        if (activeTab === 'INAPP') {
          setActiveTab(CHANNEL.INAPP)
        }
        break
      case '9':
        setCopyModal(true)
        setSelectedCampaign(rowData)
        break
      case '3':
        setSelectedCampaign(rowData)
        setShowDeleteModal(true)
        break
      default:
        break
    }
  }

  return (
    <div>
      <Toolbar
        options={options}
        onButtonClick={handleCompaignAction}
        onDropdownSelect={handleDropdown}
        dropdownData={dropdownOptions}
        buttonName="Create Campaign"
        onSearchChange={onSearchChange}
        total={total}
      />
      <div className="list__main-container">
        <Table
          data={
            activeTab === 'INAPP'
              ? (appCampaignData?.content as unknown as Campaign[])
              : data?.content || []
          }
          loading={isLoading || isAppCampaignLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={data?.size ?? 10}
          onPageChange={onPageChange}
          onSortColumn={handleSortColumn}
        >
          {columns.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                {renderCellComponent(key)}
              </Column>
            )
          })}

          <Column flexGrow={1}>
            <HeaderCell>Action</HeaderCell>
            <ActionCell
              dataKey="action"
              onAction={handleAction}
              tooltip
              disableEdit
              actionOptions={['Edit', 'Copy Compaign', 'Delete']}
            />
          </Column>
        </Table>
      </div>
      {showCopyModal && (
        <Modal
          open={showCopyModal}
          onClose={() => setCopyModal(false)}
          title="Confirm Duplicate"
          size="calc(40% - 120px)"
          className="delete-modal"
          body={
            <div className="modal-content">
              <p className="modal-text">
                Are you sure want to Duplicate this Campaign?
              </p>
              <div className="modal-buttons">
                <div>
                  <Button
                    onClick={() => setCopyModal(false)}
                    appearance="primary"
                    color="red"
                    className="no-btn"
                  >
                    No
                  </Button>
                </div>
                <div>
                  <Button
                    onClick={() =>
                      selectedCampaign && handleConfirmCopy(selectedCampaign)
                    }
                    appearance="primary"
                    className="yes-btn"
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      )}
      {showDeleteModal && (
        <Modal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          title="Confirm Delete"
          size="calc(40% - 120px)"
          className="delete-modal"
          body={
            <div className="modal-content">
              <p className="modal-text">
                Are you sure want to delete this Campaign?
              </p>
              <div className="modal-buttons">
                <div>
                  <Button
                    onClick={() => setShowDeleteModal(false)}
                    appearance="primary"
                    color="red"
                    className="no-btn"
                  >
                    No
                  </Button>
                </div>
                <div>
                  <Button
                    onClick={() => handleConfirmDelete()}
                    appearance="primary"
                    className="yes-btn"
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      )}
      {openCampaignmodal && (
        <CreateEditCampaign
          open={openCampaignmodal}
          campaign={selectedCampaign}
          isCopyMode={isCopyMode}
          isEditMode={isEditMode}
          defaultType={
            activeTab === 'INAPP'
              ? 'INAPP'
              : activeTab === 'SMS'
                ? 'SMS'
                : 'WHATSAPP'
          }
          onClose={onclose}
        />
      )}
    </div>
  )
}
export default CampaignList
